import { render, staticRenderFns } from "./UpdateKeyForBuilding.vue?vue&type=template&id=e4c495c4&"
import script from "./UpdateKeyForBuilding.vue?vue&type=script&lang=js&"
export * from "./UpdateKeyForBuilding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports